module.exports = __webpack_public_path__ + "img/zh-box.09cebe50.png";